export default __webpack_public_path__ + "static/media/Hail_To_the_Chief.d2acef34.mp3";